import saveAs from 'file-saver';
import * as XLSX from 'xlsx';
import { getContactsMessageHistory } from 'API/linkedin-funnel';

/**
 * Enriched Excel export (legacy-shaped rows) for one or more campaigns.
 */
export async function exportCampaignMessageHistoryToExcel(
  funnelIds: string[],
  token: string | null | undefined,
): Promise<boolean> {
  if (!token || funnelIds.length === 0) return false;

  let aggregated: unknown[] = [];
  for (const funnelId of funnelIds) {
    const res = await getContactsMessageHistory(funnelId);
    if (!res.error && res.messages) {
      aggregated = aggregated.concat(res.messages);
    }
  }

  if (aggregated.length === 0) return false;

  const headers = [
    'First Name',
    'Last Name',
    'Email',
    'Phone Number',
    'LinkedIn URL',
    'Vanity URL',
    'Custom Field',
    'AI Judgement',
    'AI Judgement Explanation',
    'AI Judgement Date',
    'Judging Summary',
    'jointPosPower',
    'jointPosAffil',
    'jointPosAchieve',
    'authenticity',
    'regFocus',
    'Direction',
    'Date',
    'Function Name',
    'Step Index',
    'Text',
    'Match',
    'Response Type',
    'Outcome',
  ];

  const rows = aggregated.map((entry: any) => {
    const c = entry.contact || {};
    const m = entry.message || {};
    return [
      c.firstName || '',
      c.lastName || '',
      c.email || '',
      c.phoneNumber || '',
      c.linkedinUrl || '',
      c.vanityUrl || '',
      c.customField || '',
      c.aiJudging?.aiJudgement || '',
      c.aiJudging?.aiJudgementExplanation || '',
      c.aiJudging?.aiJudgementDate ? new Date(c.aiJudging.aiJudgementDate).toLocaleString() : '',
      c.judgingInformation?.shortSummary || '',
      c.judgingInformation?.assessment?.jointPosPower ?? '',
      c.judgingInformation?.assessment?.jointPosAffil ?? '',
      c.judgingInformation?.assessment?.jointPosAchieve ?? '',
      c.judgingInformation?.assessment?.authenticity ?? '',
      c.judgingInformation?.assessment?.regFocus ?? '',
      m.direction || '',
      m.date ? new Date(m.date).toLocaleString() : '',
      m.step?.functionName || '',
      m.step?.stepIndex ?? '',
      (m.text || '').replace(/\n/g, ' '),
      m.match ?? '',
      m.responseType ?? '',
      m.outcome ?? '',
    ];
  });

  const worksheetData = [headers, ...rows];
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(worksheetData);
  XLSX.utils.book_append_sheet(wb, ws, 'Message History');

  const blob = XLSX.write(wb, { type: 'array', bookType: 'xlsx' });
  saveAs(new Blob([blob], { type: 'application/octet-stream' }), 'message_history.xlsx');
  return true;
}
